import React from 'react';
import PropTypes from 'prop-types';
import icons from '../Icon/Icons';
import './SearchBar.scss';

/**
 * Reusable SearchBar component with glassmorphism styling
 *
 * @param {string} value - Current search value
 * @param {function} onChange - Callback function when search value changes
 * @param {string} placeholder - Placeholder text for the input
 * @param {string} className - Additional CSS classes
 * @param {boolean} disabled - Whether the search input is disabled
 * @param {function} onClear - Optional callback for clear button
 * @param {boolean} showClearButton - Whether to show clear button when there's text
 */
export const SearchBar = ({
  value = '',
  onChange,
  placeholder = 'Search...',
  className = '',
  disabled = false,
  onClear,
  showClearButton = true,
  customStyle = {},
}) => {
  const handleInputChange = (e) => {
    if (onChange) {
      onChange(e.target.value);
    }
  };

  const handleClear = () => {
    if (onClear) {
      onClear();
    } else if (onChange) {
      onChange('');
    }
  };

  return (
    <div className={`search-bar ${className} ${disabled ? 'disabled' : ''}`}>
      <icons.Search_Magnifying_Glass className='search-icon' />
      <input
        type='text'
        className='search-input'
        placeholder={placeholder}
        value={value}
        onChange={handleInputChange}
        disabled={disabled}
        style={customStyle}
      />
      {showClearButton && value && (
        <button
          type='button'
          className='clear-button'
          onClick={handleClear}
          aria-label='Clear search'
        >
          <icons.Close_MD />
        </button>
      )}
    </div>
  );
};

SearchBar.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  onClear: PropTypes.func,
  showClearButton: PropTypes.bool,
};
